<div class="p-8">
    <app-loader *ngIf="isLoading"></app-loader>
    <div class="flex items-center justify-between">
        <h2 class="text-2xl font-bold">Edit User Permissions</h2>
        <div class="flex justify-end space-x-4" *ngIf="!hideSubmitBtn">
            <button (click)="onCancel()">
                Cancel
            </button>
            <button (click)="onSubmit()"
                class="btn-3 bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600">
                Submit
            </button>
        </div>
    </div>
    <div class="mt-8 flex justify-between items-center">
        <div class="textarea-cotaniner flex items-center">
            <textarea type="text" id="simple-search" class="br-1 text-area btn-1 border-gray-200 org-name block p-3"
                [ngClass]="outlineUserName ? 'outline' : ''" (focus)="onFocus()" disabled readonly placeholder="Enter User Name"
                [(ngModel)]="userName"> </textarea>

                <div class="p-auto flex margin justify-center org-cotent items-center rounded-lg mr-4">
                    <select name="labNames" id="" [ngClass]="outlineOrg ? 'outline' : ''" (focus)="onOrgFocus()"
                     class="btn-2 border-gray-200 rounded-lg org-name"
                    (change)="onChange($event)" [(ngModel)]="organizationId">
                    <option value="" class="org-name">Select Organization</option>
                    <ng-container *ngFor="let org of orgList">
                    <option class="input-style" [value]="org.orgId">{{org.orgName}}</option>
                        </ng-container>
                    </select>
                </div>
        </div>

        <div class="p-auto flex justify-center items-center rounded-lg mr-1">
            <select name="defaulPermissions" id=""
             class="btn-2 border-gray-200 rounded-lg GroupDropdown" [(ngModel)]="selectedDefaultPermission"
            (change)="handleDefaultPermission($event)">
            <option value="" class="">Select Default Permission</option>
            <ng-container *ngFor="let labUsers of permissionsForLabUsers">
            <option class="input-style" [value]="labUsers.value">{{labUsers.label}}</option>
                </ng-container>
            </select>
        </div>

        <div>
            <input id="default-checkbox" type="checkbox" value="" [(ngModel)]="overallSelect"
                (change)="toggleOverallSelect($event)"
                class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <label for="default-checkbox" style="margin-left: 10px;"
                class="ms-10 text-xl text-sm font-medium text-gray-900 dark:text-gray-300 select">Select Overall
                Permissions
            </label>
        </div>
    </div>

    <div *ngFor="let module of permissionsByType" class="mt-4 p-8 bg-white shadow-xl border-slate-200 category-div">
        <div class="mb-8">
            <div class="flex justify-between">
                <div class="mb-4">
                    <h2 class="text-xl font-bold permission-type">{{ module.type }}</h2>
                </div>
                <div>
                    <input id="default-checkbox" type="checkbox" (change)="toggleSelectAll(module, $event)"
                        [checked]="changeStatus(module)"
                        class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                    <label for="default-checkbox"
                        class="ml-2 text-xl font-medium text-gray-900 dark:text-gray-300 select">Select all</label>
                </div>
            </div>

            <div class="flex-wrap-container mt-4">
                <div *ngFor="let permission of module.permissions" class="category-div1">
                    <input [id]="permission.permissionId" type="checkbox" [(ngModel)]="permission.hasPermission"
                        (change)="changeStatus(module)"
                        class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 mr-2 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                    <label [for]="permission.permissionId"
                        class="ml-2 pt-10 text-xl font-medium text-gray-900 dark:text-gray-300 select">{{
                        permission.displayName | titlecase }}</label>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-8 flex justify-end space-x-4" *ngIf="!hideSubmitBtn">
        <button (click)="onCancel()">
            Cancel
        </button>
        <button (click)="onSubmit()"
            class="btn-3 bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600">
            Submit
        </button>
    </div>
</div>